import type { CSSProperties, FC, ReactNode } from 'react'

import { useRef } from 'react'
import { useScrollProgress } from '@/hooks/use-scroll-progress'
import { UI } from '@/constants/media'

/** Two working sheets stacked like paper on a desk; they drift apart as the page moves. */
export const KalkHeroVisual: FC = (): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)

    useScrollProgress(ref, { startAt: 1, endAt: 0 })

    return (
        <div ref={ref} className='kalk-hero load-fade relative mx-auto aspect-[1/1.02] w-full max-w-[40rem]' style={{ '--load-delay': '0.45s' } as CSSProperties}>
            <div className='kalk-sheet kalk-sheet-back absolute left-0 top-[6%] w-[64%] bg-chalk p-2 shadow-2xl' data-motion>
                <img src={UI.tilbudEditor} alt='Redigering av et tilbud i Svenn Kalkulasjon' decoding='async' className='w-full' />
            </div>

            <div className='kalk-sheet kalk-sheet-front absolute bottom-[2%] right-0 w-[66%] bg-chalk p-2 shadow-2xl' data-motion>
                <img src={UI.pristilbudPdf} alt='Ferdig pristilbud med logo, poster og totalsum' fetchPriority='high' decoding='async' className='w-full' />
            </div>

            <div className='absolute right-0 top-0 w-[33%] text-tone-fg'>
                <span className='kalk-clock tabular block'>15</span>
                <span className='t-label mt-2 block text-signal'>Minutter</span>
                <span className='mt-2 block text-sm text-tone-muted'>fra kalkyle til ferdig, nedlastet pristilbud</span>
            </div>
        </div>
    )
}
